import React, { useContext, useState, useEffect, createContext } from "react";
import { getAllCoins } from "../http/coins";

const CoinsContext = createContext({});
export const CoinsProvider = ({ children }) => {
  const [coins, setCoins] = useState([]);
  useEffect(() => {
    // const interval = setInterval(() => {
    // }, 30000);
    // return () => clearInterval(interval);
    getAllCoins()
      .then((response) => setCoins(response.data))
      .catch((error) => console.log(error));
  }, []);
  return (
    <CoinsContext.Provider value={{ coins }}>{children}</CoinsContext.Provider>
  );
};

export function useCoins() {
  const context = useContext(CoinsContext);
  return context;
}
